import { FaBriefcase, FaUser } from "react-icons/fa";
import { BsLink45Deg } from "react-icons/bs"
import { BiDetail } from "react-icons/bi";
import { GrDocumentTime } from "react-icons/gr";
import { ImInsertTemplate } from "react-icons/im";
import { HiOutlineWallet } from "react-icons/hi2";
import { IconContext } from "react-icons";
import { NavLink } from "react-router-dom";
import Tooltip from "../../../components/tooltip/Tooltip";
import "../Sidebar.css";
import { useMemo } from "react";

function RecruiterSidebar() {
  const user = JSON.parse(sessionStorage.getItem("User"))
  const value = useMemo(() => ({
    color: "gray",
    size: "40px",
  }), []);

  return (
    <nav className="sidebar" id="manager-sidebar">
      <IconContext.Provider
        value={value}
      >
        <div className="team-nav-group nav-group" id="step-sidebar">
            <div>
              <div id="step-3">
                <Tooltip content="Manage Jobs" direction="right">
                  <NavLink
                    to="/manage-jobs"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FaBriefcase />
                  </NavLink>
                </Tooltip>
              </div>
              <Tooltip content="My Dashboard" direction="right">
                <NavLink to="/summary" className={({ isActive }) => isActive ? "active" : "" }>
                  <ImInsertTemplate />
                  {/* <MdSummarize /> */}
                </NavLink>
              </Tooltip>
      
              <Tooltip content="My Daily Diary" direction="right">
                <NavLink to="/diary" className={({ isActive }) => isActive ? "active" : "" }>
                  <BiDetail />
                </NavLink>
              </Tooltip>
      
              <Tooltip content="My Info" direction="right">
                <NavLink to="/profile/info" className={({ isActive }) => isActive ? "active" : "" }>
                  <FaUser />
                </NavLink>
              </Tooltip>

              <Tooltip content="My payments" direction="right">
                <NavLink
                  to="/profile/payment"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <HiOutlineWallet />
                </NavLink>
              </Tooltip>
      
              {!user.disabled &&(
                <Tooltip content="Links" direction="right">
                  <NavLink to="/profile/links" className={({ isActive }) => isActive ? "active" : "" }>
                    <BsLink45Deg />
                  </NavLink>
                </Tooltip>
              )}
      
              <Tooltip content="My Manual Time" direction="right">
                <NavLink to="/profile/requests" className={({ isActive }) => isActive ? "active" : "" }>
                  <GrDocumentTime />
                </NavLink>
              </Tooltip>
            </div>
        </div>

      </IconContext.Provider>
    </nav>
  );
}

export default RecruiterSidebar;
